export const DiffLineType = {
  Addition: 'ADDITION',
  Context: 'CONTEXT',
  Deletion: 'DELETION',
  Hunk: 'HUNK',
  InjectedContext: 'INJECTED_CONTEXT',
  Empty: 'EMPTY',
} as const
export type DiffLineType = (typeof DiffLineType)[keyof typeof DiffLineType]

export const DiffLineTypeCharacter = {
  [DiffLineType.Addition]: '+',
  [DiffLineType.Deletion]: '-',
  [DiffLineType.Context]: ' ',
  [DiffLineType.Hunk]: '@',
  [DiffLineType.InjectedContext]: '~',
} as const
export type DiffLineTypeCharacter = (typeof DiffLineTypeCharacter)[keyof typeof DiffLineTypeCharacter]

export interface SimpleDiffLine {
  left: number | null
  html: string
  right: number | null
  type: DiffLineType
}

export interface DiffLine extends SimpleDiffLine {
  text: string
}

export type DiffAnchor = `diff-${string}`
